import React from 'react';

import { DarkSkeleton } from '@eika/skeleton';

interface Props {
    isDesktop: boolean;
}

const LoanActionSkeleton: React.FC<Props> = ({ isDesktop }) => {
    return (
        <div className="loan-actions__wrapper loan-account-actions loan-actions-skeleton">
            <DarkSkeleton width={isDesktop ? 160 : 80} height={isDesktop ? 120 : 80} circle={!isDesktop} />
            <DarkSkeleton width={isDesktop ? 160 : 80} height={isDesktop ? 120 : 80} circle={!isDesktop} />
        </div>
    );
};

export default LoanActionSkeleton;
